// eslint-disable-next-line no-unused-vars
import React from 'react';
import { string, object, node } from 'prop-types';
import { Link } from 'react-router-dom';

import useAnalytics from 'Hooks/useAnalytics';

const isInternalLink = url => {
  if (typeof url !== 'string') {
    return false;
  }

  if (!url.startsWith('http://') && !url.startsWith('https://') && !url.startsWith('//')) {
    return true;
  }

  try {
    const linkUrl = new URL(url, window.location.origin);
    return linkUrl.origin === window.location.origin;
  } catch {
    return false;
  }
};

const AnalyticsLink = ({ className, to, event, children, ...rest }) => {
  const analytics = useAnalytics();
  const isInternal = isInternalLink(to);

  const handleLinkClick = ({ action, params }) => {
    analytics.track(action, params);
  };

  const onClick = e => {
    handleLinkClick(event);

    if (!isInternal) {
      e.preventDefault();
      setTimeout(() => {
        window.open(to, '_blank');
      }, 100);
    }
  };

  return isInternal ? (
    <Link className={ className } to={ to } onClick={ onClick } { ...rest }>
      { children }
    </Link>
  ) : (
    <a className={ className } href={ to } onClick={ onClick } { ...rest }>
      { children }
    </a>
  );
};

AnalyticsLink.propTypes = {
  className: string,
  to: string.isRequired,
  event: object.isRequired,
  children: node.isRequired,
};

export { AnalyticsLink };
